export default __webpack_public_path__ + "static/media/vegan-products-in-retail.fbafe5ea.png";